/* eslint-disable react/no-array-index-key */
import OutlineQuestionCircle from 'assets/icons/outline-question-circle.svg?react';
import { useIntl } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';
import isRecord from 'utils/isRecord';
import Modal, { useModal } from '../Modal';
import s from './ScreenLink.module.scss';

interface IScreenLinkElement {
  type: string;
  text: string;
}

interface IScreenLinkContent {
  key: number;
  image: { src?: unknown };
  description: IScreenLinkElement[];
}

export interface IScreenLinkData {
  type?: string;
  title: string;
  content: IScreenLinkContent[];
}

interface IScreenLinkProps {
  linkData: IScreenLinkData;
}

// Bug: the images are imported as URLs (strings), so `src.default` is undefined and the images
// of the equipment type modal never load.
const imageUrlOf = (src: unknown) =>
  isRecord(src) && typeof src.default === 'string' ? src.default : undefined;

const GetElement = ({ type, text }: IScreenLinkElement) => {
  const { formatMessage: t } = useIntl();
  switch (type) {
    case 'title':
      return <h3>{t({ id: text })}</h3>;
    case 'paragraph':
      return <p>{t({ id: text })}</p>;
    default:
      return null;
  }
};

const ScreenLink = ({ linkData }: IScreenLinkProps) => {
  const { showModal, hideModal, isVisible } = useModal();
  const { formatMessage: t } = useIntl();
  return (
    <>
      <Modal
        isVisible={isVisible}
        close={hideModal}
        headerText={t({ id: 'project_plan.equipment_type' })}
      >
        <Grid>
          {linkData.content.map(({ key, image, description }, i) => (
            <Row key={key} className={s.row}>
              <Col md={12} lg={6}>
                <img src={imageUrlOf(image.src)} height="500px" alt="" />
              </Col>
              <Col md={12} lg={6}>
                {description.map((el) => (
                  <GetElement key={`${el.type}_${i}`} {...el} />
                ))}
              </Col>
            </Row>
          ))}
        </Grid>
      </Modal>
      <button onClick={showModal} className={cn('link', s.showModalBtn)} type="button">
        <OutlineQuestionCircle />
      </button>
    </>
  );
};

export default ScreenLink;
